import { ThemeUICSSObject, focusOutline, spacing } from '@apia/theme';

const tree: ThemeUICSSObject = {
  p: spacing(7),
  background: 'palette.background.paper',

  '.tree__expanderWrapper': {
    display: 'flex',
    alignItems: 'center',
    height: '36px',
  },

  'span.tree__nodeItemLabel': {
    gap: 0,
    overflow: 'hidden',
    height: '36px',
  },

  '.hierarchicalStructureNodePoolButton': {
    color: 'palette.text.primary',
    backgroundColor: 'transparent',
    flexShrink: 0,
    width: 'iconSm',
    height: 'iconSm',
    borderRadius: '100%',
  },

  '.hierarchicalStructureNode': {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(3),
    pl: 3,

    '&:focus': focusOutline,
  },

  '.hierarchicalStructureNodePoolName': {
    flexShrink: 0,
  },

  '.hierarchicalStructureNodePoolInfo': {
    flexShrink: 1,
    overflow: 'hidden',

    '.hierarchicalStructureNodePoolDesc, .hierarchicalStructureNodePoolUnit': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      flexShrink: 1,
      lineHeight: 1.1,
    },
  },
};

export default tree;
